import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import './ReviewAndApproveHeader.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {useReviewHeaderContext} from '../../header/ReviewHeader';

const ReviewAndApproveHeader = ({
  title,
  approveButtonLabel,
  handleCancel,
  handleApprove,
}: {
  title: string;
  approveButtonLabel: string;
  handleCancel: () => void;
  handleApprove: () => void;
}) => {
  const {hasValidationErrors, showEditProtocolIntelligence, isProtocolUpdated} =
    useReviewHeaderContext();
  return (
    <Box className="review-approve-content-header">
      <Box className="review-approve-content-header-text-wrapper">
        <Box
          className="review-approve-content-header-text-title"
          aria-label={t('ai.review.reviewAndApprove.title')}
          tabIndex={0}
        >
          {showEditProtocolIntelligence ? <span>Edit</span> : null}
          <Typography className="typo-text headline3_size ">{title}</Typography>
        </Box>
      </Box>
      <Box
        className="review-approve-action-buttons"
        data-testid="action-buttons"
      >
        <ArrButton
          variant="secondary"
          size="medium"
          onClick={handleCancel}
          aria-label={t('ai.review.reviewAndApprove.cancel')}
          dataTestId="review-and-approve-header-cancel-button"
        >
          {t('ai.review.reviewAndApprove.cancel')}
        </ArrButton>
        <ArrButton
          variant={showEditProtocolIntelligence ? 'secondary' : 'primary'}
          size="medium"
          onClick={handleApprove}
          disabled={
            hasValidationErrors ||
            (showEditProtocolIntelligence && !isProtocolUpdated)
          }
          aria-label={t('ai.review.reviewAndApprove.approve')}
          dataTestId="approve-button"
        >
          {approveButtonLabel}
        </ArrButton>
      </Box>
    </Box>
  );
};

export default ReviewAndApproveHeader;
